import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { usePasswordRecovery } from "hooks/accountManagement/useAccountRecovery";
import SecurityQuestions from "./securityList";
import { Card } from "react-bootstrap";

export default function AccountSecurityQuestions() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const recoveryId = state?.recoveryId;
  const questions = state?.questions || [];

  const { verifyAnswers, loading, error } = usePasswordRecovery();

  if (!recoveryId || questions.length === 0) {
    return (
      <div className="text-center mt-5 text-danger">
        Invalid recovery session. Please start again.
      </div>
    );
  }

  const handleSubmit = async (payload) => {
    try {
      // Call verifyAnswers from your hook with recoveryId and answers
      const data = await verifyAnswers(payload);
      
      // On success, navigate to password reset step with resetToken from response
      navigate("/authentication/split/reset-password", { state: { resetToken: data.resetToken } });
    } catch (err) {
      console.error("Verification failed:", err.response?.data || err.message);
    }
  };

  const handleCancel = () => {
    navigate("/login");
  };

  return (
 <Card.Body>
  
    <SecurityQuestions
      recoveryId={recoveryId}
      questions={questions}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      loading={loading}
      error={error}
    />
        </Card.Body>
  );
}
